/* eslint-disable react/prop-types */
import './index.scss';
import ModalBase from '.';
import { ModalProps } from '../../types';
import ModalExecuteAction from './ModalExecuteAction';
import { useEffect, useState } from 'react';
import { Alert, Input } from '@piggytechng/component-library';
import { OverideInputStyle } from '../../helpers/utils';
import useCustomers from '../../hooks/useCustomers';

const NIN_LENGTH = 11;

// Verify a customer's NIN: 11-digit input (ModalAction input pattern), then the
// ModalExecuteAction password step, then POST admin/user/nin/verify/:userId.
function ModalVerifyNin({ modalIsOpen, setIsOpen, actionColor = '#0B5ED7' }: ModalProps) {
  const [nin, setNin] = useState('');
  const [showExecuteAction, setShowExecuteAction] = useState(false);
  const { verifyUserNin, isRunningUserAction } = useCustomers();

  useEffect(() => {
    if (modalIsOpen) setNin('');
  }, [modalIsOpen]);

  const isValidNin = nin.length === NIN_LENGTH;

  const closeAll = () => {
    setShowExecuteAction(false);
    setIsOpen(false);
    setNin('');
  };

  const onContinue = (e: { preventDefault: () => void }) => {
    e.preventDefault();
    if (!isValidNin) {
      Alert.error('NIN must be exactly 11 digits');
      return;
    }
    setIsOpen(false);
    setShowExecuteAction(true);
  };

  return (
    <>
      <ModalBase modalIsOpen={modalIsOpen} setIsOpen={setIsOpen}>
        <div className={`modal-base general success action modal-action flex--4`}>
          <span onClick={closeAll}>&times;</span>
          <form style={{ display: 'flex', flexDirection: 'column', gap: '20px' }} action="" onSubmit={onContinue}>
            <h4>Verify NIN</h4>

            <Input
              {...OverideInputStyle}
              label="NIN"
              id="nin"
              name="nin"
              className="user-form-input"
              placeholder="Enter the 11-digit NIN"
              onChange={(e) => setNin(e.target.value.replace(/\D/g, '').slice(0, NIN_LENGTH))}
              value={nin}
            />

            <div className="button-cont flex--2">
              <button type="button" onClick={closeAll}>
                Cancel
              </button>
              <button
                type="submit"
                onClick={onContinue}
                style={{ backgroundColor: actionColor }}
                disabled={!isValidNin}
              >
                Verify
              </button>
            </div>
          </form>
        </div>
      </ModalBase>

      <ModalExecuteAction
        modalIsOpen={showExecuteAction}
        setIsOpen={setShowExecuteAction}
        isLoading={isRunningUserAction}
        actionColor={actionColor}
        text={`verify NIN ${nin} for this customer?`}
        action={(password: string) => verifyUserNin(nin, password, closeAll)}
      />
    </>
  );
}

export default ModalVerifyNin;
